module.exports = __webpack_public_path__ + "img/picture.7d34de9a.png";